import commonComponents from '@/components/renderers';

export const registerComponents = (app) => {
  commonComponents.forEach(component => {
    app.component(component.name, component);
  });
};
